import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { ShieldCheck } from "@phosphor-icons/react";

const ACTION_LABELS = {
  login_success: "Login riuscito",
  login_failed: "Login fallito",
  logout: "Logout",
  patient_created: "Paziente creato",
  patient_updated: "Paziente modificato",
  patient_pin_rotated: "PIN rigenerato",
  patient_soft_deleted: "Paziente eliminato",
  patient_hard_deleted: "Eliminazione definitiva (GDPR)",
  file_uploaded: "File caricato",
  file_deleted: "File eliminato",
  user_created: "Utente creato",
  user_updated: "Utente modificato",
  user_deleted: "Utente eliminato",
  settings_updated: "Impostazioni aggiornate",
  logo_uploaded: "Logo aggiornato",
  portal_access_granted: "Accesso portale paziente",
  portal_pin_failed: "PIN portale errato",
  followup_generated: "Follow-up AI generato",
  followup_saved: "Follow-up AI salvato",
  followup_deleted: "Follow-up eliminato",
  twin_synthesis_generated: "Gemello Digitale: sintesi AI",
  twin_visit_report_generated: "Gemello Digitale: dossier pre-visita",
  portal_check_in: "Check-in dal portale paziente",
  portal_photo_uploaded: "Foto caricata dal paziente",
  alert_dismissed: "Alert chiuso",
};

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/audit-logs", { params: { limit: 500 } });
        setLogs(data);
      } catch (e) {
        setError(formatApiError(e.response?.data?.detail) || e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="space-y-6 fade-up" data-testid="audit-logs-page">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-brand-400 flex items-center gap-2"><ShieldCheck size={14} weight="duotone" /> Conformità GDPR</div>
        <h1 className="font-heading text-3xl sm:text-4xl font-medium tracking-tight text-[#1C2321] mt-2">Registro attività</h1>
        <p className="text-[#56635D] mt-2">Tracciamento delle azioni effettuate sugli archivi pazienti.</p>
      </div>

      {error && <div className="text-sm text-[#A84A4A] bg-[#A84A4A]/10 rounded-lg px-3 py-2">{error}</div>}

      <div className="elev-card p-0 overflow-hidden">
        <div className="hidden md:grid grid-cols-[180px_160px_1fr_120px_140px] gap-4 px-5 py-3 bg-[#F0F0EE] text-[10px] font-mono uppercase tracking-[0.18em] text-[#56635D] border-b border-[#E6E8E6]">
          <div>Timestamp</div><div>Utente</div><div>Azione</div><div>Entità</div><div>IP</div>
        </div>
        {loading ? (
          <div className="p-6 text-[#56635D]">Caricamento…</div>
        ) : logs.length === 0 ? (
          <div className="p-6 text-[#56635D]">Nessun evento.</div>
        ) : (
          <div className="divide-y divide-[#E6E8E6]" data-testid="audit-logs-list">
            {logs.map((l) => (
              <div key={l.id} className="px-5 py-3 grid grid-cols-1 md:grid-cols-[180px_160px_1fr_120px_140px] gap-2 md:gap-4 text-sm" data-testid={`log-${l.id}`}>
                <div className="font-mono text-xs text-[#56635D]">{new Date(l.timestamp).toLocaleString("it-IT")}</div>
                <div className="text-xs text-[#56635D] truncate">{l.user_email || "anonimo"}</div>
                <div className="text-[#1C2321]">{ACTION_LABELS[l.action] || l.action}</div>
                <div className="font-mono text-xs text-[#56635D] truncate">{l.entity_type}{l.entity_id ? ` · ${l.entity_id.slice(0, 8)}` : ""}</div>
                <div className="font-mono text-xs text-[#56635D]">{l.ip || "-"}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
